<template>
  <div class="full-page-width relative locations" style="margin-top: 81px">
    <div class="row">
      <div class="col-xs-4 text-box">
        <InfoTextBox
          :text="$t('reports-info-text')"
          :title="$t('reports-header-text')"
          :btnText="$t('create_report')"
          @action="addReport" />
      </div>
      <div class="col-xs-8" @mouseover="upHere = true" @mouseleave="upHere = false">
        <ul class="list-table">
          <li
            class="list-table-item"
            v-for="(item, index) in get_reports_list.items"
            :key="`item-${index}`">
            <div class="table-cell small">
              <Icon v-show="get_reports_list.entity.types[item.type] === 'contacts'" :circle=true name="team" size="20"/>
              <Icon v-show="get_reports_list.entity.types[item.type] === 'shipments'" :circle=true name="truck" size="20"/>
              <Icon v-show="get_reports_list.entity.types[item.type] === 'item_catalog'" :circle=true name="products" size="20"/>
            </div>
            <div class="table-cell">
              <div>
                <span class="main-info"  style="display: inline-block;">
                  {{ `${$t(get_reports_list.entity.types[item.type])}` }}
                </span>
                <span class="additional-info" style="display: inline-block; margin-left: 5px;">
                  ({{ `${item.created_at}` }} {{ $t('by') }} {{ `${item.user_name}` }})
                </span>
                <div v-if="isInProgress(item.id) && getActivePercent(item.id) < 100">
                  <div class="upload-bar-holder relative">
                    <span class="upload-bar" :style="{width: getActivePercent(item.id) + '%' }"></span>
                    <p class="upload-bar-text" >{{ getActivePercent(item.id) }} %</p>
                  </div>
                </div>
                <span
                  v-else
                  class="color-brend"
                  style="display: block; font-size: 15px"
                  @click="downloadReport(item.id, item.type, item.file_type)">
                    {{ $t('click_to_download') }}
                  </span>
              </div>
              <p style="margin-top: 5px;">
                <span class="additional-info" style="padding-top:5px;" v-for="(filter, index) in item.filters" :key=index >{{ `${handleFilters(filter)}` }}</span>
              </p>
              <Btn
                v-show="upHere & (!isInProgress(item.id) || getActivePercent(item.id) >= 100)"
                class="red d-inline-block m-r-15"
                :icon="{
                name: 'deleteForever',
                 size: '16',
                 }"
                :btnText="$t('delete')"
                @btnClick="deleteReport(item.id)"/>
            </div>
          </li>
        </ul>
      </div>
      <a
        style="display: none"
        :download="downloadName"
        ref="downloadReportref"
        :href="reportCsvPath" />
    </div>
    <Popup
      v-if="openPopup"
      :popupMedium=true
      min-height="300px"
      @cancel="togglePopup"
      @confirm="submitForm">
      <template v-slot:header>
        <h2>{{ $t('create_report') }}</h2>
      </template>
      <div>
        <div>
          <InputSelect
            class="m-b-20"
            :label="$t('type')"
            :rules="{required: true}"
            v-model="form.type"
            @change="setDefaultFields"
            :options="selectOptions(get_reports_list.entity['types'])"
          />
          <InputSelect
            class="m-b-20"
            :label="$t('file_type')"
            :rules="{required: true}"
            v-model="form.file_type"
            :options="[{text: 'Csv', value: 'csv'}, {text: 'Xlsx', value: 'xlsx'}]"
          />
        </div>
        <div class="relative" v-if="form.type">
          <ul>
            <li v-for="(option, key, index) in filterOptions" :key="`filter-option${index}`">
              <!-- INPUT TEXT -->
              <PlaceHolderComponent
                :label="option.label"
                @cleanInputEvent="deleteData(key)"
                @keypress.native="onValueChange(key)"
                @click.native="onValueChange(key)"
                >
                <div v-if="option.type === 'input'">
                  <InputText
                    class="d-block"
                    v-model="formFields[key].value"/>
                </div>
                <!-- ADDITIONAL OPTIONS -->
                <div v-if="option.type === 'options'" class="flex">
                  <InputSelect
                    class="m-b-20 m-r-15 w-full"
                    v-model="formFields[key].additional"
                    :options="additionalOptions"/>
                  <InputText
                    type="number"
                    class="d-block m-b-20 w-70"
                    v-model="formFields[key].value"/>
                </div>
                <!-- INPUT SELECT -->
                <div v-if="option.type === 'select'">
                  <InputSelect
                    class="m-b-20"
                    v-model="formFields[key].value"
                    :options="option.options"/>
                </div>
                <!-- COUNTRIES -->
                <div v-if="option.type === 'country'">
                  <CountrySelect
                    :multiSelect="true"
                    :preselected="formFields[key].value"
                    @change="selectCountries"
                    class="m-b-20"/>
                </div>
                <div v-if="option.type === 'shippingAgent'">
                  <ShippingAgentSelect
                    :multiSelect="true"
                    :preselected="Array.isArray(formFields[key].value) ? formFields[key].value : [] "
                    @change="selectShippingAgents($event, key)"
                    class="m-b-20" />
                </div>
                <!-- SUBACCOUNTS  -->
                <div v-if="option.type === 'subaccount'">
                  <SubaccountSelect
                    :multiSelect="true"
                    :preselected="Array.isArray(formFields[key].value) ? formFields[key].value : [] "
                    @change="selectSubaccounts($event, key)"
                    class="m-b-20" />
                </div>
                <!-- CALENDAR -->
                <div v-if="option.type === 'date'" class="row" style="margin: 0;">
                  <div class="col-xs-6 m-b-20">
                    <Calendar
                      :disable-weekend="false"
                      :noMinDate="true"
                      :label="$t('from_date')"
                      :noDate="true"
                      v-model="formFields[key].value.fromDate"/>
                  </div>
                  <div class="col-xs-6 m-b-20">
                    <Calendar
                      :disable-weekend="false"
                      :noMinDate="true"
                      :label="$t('to_date')"
                      :noDate="true"
                      v-model="formFields[key].value.toDate"/>
                  </div>
                  <div class="clearfix"></div>
                </div>
<!--                <Calendar-->
<!--                  v-if="option.type === 'date'"-->
<!--                  :disable-weekend="false"-->
<!--                  :noDate=true-->
<!--                  :noMinDate="true"-->
<!--                  v-model="formFields[key].value"/>-->
              </PlaceHolderComponent>
            </li>
          </ul>
        </div>
      </div>
    </Popup>
  </div>
</template>

<script>/* eslint-disable */
import {mapGetters} from 'vuex';
import Btn from '@/components/elements/buttons';
import InputText from '@/components/elements/inputs/text.vue';
import Calendar from '@/components/elements/inputs/calendar.vue';
import CountrySelect from '@/components/elements/inputs/countrySelect.vue';
import Popup from '@/components/global/popup';
import InputSelect from '@/components/elements/inputs/select.vue';
import PhoneSelect from '@/components/elements/inputs/phone.vue';
import Toggle from '@/components/elements/inputs/toggle.vue';
import LogosSVG from "@/assets/images/logosSVG";
import UploadTemplate from '@/components/global/uploadTemplate';
import InfoTextBox from '@/components/global/infoTextBox';
import PlaceHolderComponent from '@/components/global/sidebar/placeholder.vue';
import ProgressCard from '@/components/global/progressCard';
import SubaccountSelect from "@/components/elements/inputs/subaccountSelect.vue";
import ShippingAgentSelect from "@/components/elements/inputs/shippingAgentSelect.vue";
import countryList from "@/data/country";
import i18n from "@/i18n";

export default {
  name: 'Reports',
  components: {
    ShippingAgentSelect, SubaccountSelect,
    Btn,
    InputText,
    Calendar,
    CountrySelect,
    Popup,
    InputSelect,
    PhoneSelect,
    Toggle,
    LogosSVG,
    UploadTemplate,
    InfoTextBox,
    PlaceHolderComponent,
    ProgressCard
  },
  computed: {
    ...mapGetters([
      'get_reports_list',
      'get_import_queue',
      'get_company_available_shipping_agents_select',
      'get_allowed_subaccounts_select_options'
    ]),
  },
  data() {
    return {
      progressId: '',
      updateIterator: 1,
      downloadName: '',
      filterOptions: {},
      openPopup: false,
      isEdit: false,
      upHere: false,
      deleteIconToggle: false,
      deleteFilterToggle: false,
      customFilterName: '',
      reportCsvPath: '',
      formFields: {},
      countries: [],
      form: {
        id: '',
        type: '1',
        file_type: 'xlsx',
        company_id: '',
        created_at: '',
        user_name: '',
        filters_json: {},
        report_csv: '',
        filters: []
      },
      additionalOptions: [
        {
          text: `${this.$t('More than')}`,
          value: '>',
        },
        {
          text: `${this.$t('Less than')}`,
          value: '<',
        },
        {
          text: `${this.$t('Equal to')}`,
          value: '=',
        },
      ],
    }
  },
  created() {
    this.$store.dispatch('GET_REPORTS');
    this.$store.dispatch('GET_COMPANY_AVAILABLE_SHIPPING_AGENTS');
  },
  methods: {
    isInProgress(id) {
      if (this.get_import_queue) {
        return this.get_import_queue.find(item => item.id == id);
      }
      return false;
    },
    getActivePercent(id) {
      if (this.get_import_queue) {
        const item = this.get_import_queue.find(item => item.id == id);
        return item.progressStatus
      }
      return 0;
    },
    setDefaultFields(type) {
      if (type == 1) {
        this.filterOptions = this.shipmentFilter()
      } else if (type == 2) {
        this.filterOptions = this.contactFilter()
      } else if (type == 3) {
        this.filterOptions = this.itemsFilter()
      } else {
        console.log('You choose wrong report type')
      }

      for (const [key, value] of Object.entries(this.filterOptions)) {
        if (key === 'shipments_count' || key === 'weight') {
          this.$set(this.formFields, key, {value: value.value.value, additional: '='});
        } else if (key === 'created_at' || key === 'ship_date') {
          this.$set(this.formFields, key, {value: {fromDate: value.fromDate.value, toDate: value.toDate.value}, additional: 'between'});
        } else {
          this.$set(this.formFields, key, {value: value.value.value, additional: ''});
        }
      }
    },
    handleFilters(filter) {
      let filterValue = filter.display_value ?? filter.value;
      let filterString = '';
      filterString += this.$t(filter.key) + ": " + this.formatFilterDataArray(filterValue, filter.key);

      return filterString !== '' ? filterString : this.$t('no_filter');
    },
    formatFilterDataArray(value, key) {
      let html = value;
      if (['receiver_country_id', 'sender_country_id'].includes(key)) {
        html = value.join(', ');
      }
      if (['shipping_agents'].includes(key)) {
        let agentsArray = [];
        value.forEach(agentId => {
          const agent = this.get_company_available_shipping_agents_select.find(item => item.value == agentId)
          if (agent) {
            agentsArray.push(agent.text);
          }
        })
        html = agentsArray.join(', ');
      }
      if (['subaccounts'].includes(key)) {
        let subAccountsArray = [];
        value.forEach(subaccountId => {
          const subAccount = this.get_allowed_subaccounts_select_options.find(item => item.value == subaccountId)
          if (subAccount) {
            subAccountsArray.push(subAccount.text);
          }
        })
        html = subAccountsArray.join(', ');
      }
      if (['dangerous_goods'].includes(key)) {
        html = value ? i18n.t('yes') : i18n.t ('no')
      }
      return html
    },
    clearLocalFormData() {
      let dataObject = {};
      for (const [key] of Object.entries(this.formFields)) {

        if (['ship_date', 'created_at'].includes(key)) {
          if (this.formFields[key].value.fromDate || this.formFields[key].value.toDate) {
            dataObject[key] = this.formFields[key];
          }
          continue;
        }

        if (!!this.formFields[key].value &&
          typeof this.formFields[key].value === 'string' ||
          !!this.formFields[key].value &&
          typeof this.formFields[key].value === 'number') {
          dataObject[key] = this.formFields[key];
        } else if (
          typeof this.formFields[key].value === 'array' &&
          this.formFields[key].value.length !== 0) {
          dataObject[key] = this.formFields[key];
        } else if (
          !!this.formFields[key].value &&
          typeof this.formFields[key].value === 'object' &&
          this.formFields[key].value.length !== 0) {
          dataObject[key] = this.formFields[key];
        }
      }

      this.form = {
        type: '',
        file_type: ''
      };
    },
    downloadReport(id, type, fileType = 'csv') {
      // Determine report name based on type
      let reportBaseName = '';

      type = parseInt(type);
      if (type === 1) {
        reportBaseName = 'shipment-report';
      } else if (type === 2) {
        reportBaseName = 'contact-report';
      } else if (type === 3) {
        reportBaseName = 'item-report';
      } else {
        reportBaseName = 'report';
      }

      // Set download name with proper extension
      this.downloadName = `${reportBaseName}.${fileType}`;
      this.$store.dispatch('DOWNLOAD_REPORT', id).then((res) => {
        this.$nextTick(() => {
          const url = window.URL.createObjectURL(new Blob([res]));
          this.$refs.downloadReportref.href = url;
          this.$refs.downloadReportref.download = this.downloadName; // Explicitly set filename
          this.reportCsvPath = url;
          this.$refs.downloadReportref.click();
          window.URL.revokeObjectURL(url);
        });
      }).catch((error) => {
        console.error('Download failed:', error);
      });
    },
    contactFilter() {
      return {
        type: {
          label: `${this.$t('contact_type')}`,
          type: 'select',
          value: {
            value: '',
          },
          options: [
            {text: `${this.$t('Business')}`, value: '1'},
            {text: `${this.$t('Private')}`, value: '2'},
          ],
        },
        shipments_count: {
          label: `${this.$t('shipments_count')}`,
          type: 'options',
          value: {
            value: '',
          },
        },
        company_name: {
          label: `${this.$t('company_name')}`,
          type: 'input',
          value: {
            value: '',
          },
        },
        name: {
          label: `${this.$t('name')}`,
          type: 'input',
          value: {
            value: '',
          },
        },
        address_1: {
          label: `${this.$t('address_1')}`,
          type: 'input',
          value: {
            value: '',
          },
        },
        post_code: {
          label: `${this.$t('post_code')}`,
          type: 'input',
          value: {
            value: '',
          },
        },
        city: {
          label: `${this.$t('city')}`,
          type: 'input',
          value: {
            value: '',
          },
        },
        country: {
          label: `${this.$t('country')}`,
          type: 'country',
          value: {
            value: [],
          },
        },
        phone: {
          label: `${this.$t('phone')}`,
          type: 'input',
          value: {
            value: '',
          },
        },
        email: {
          label: 'Email',
          type: 'input',
          value: {
            value: '',
          },
        },
      }
    },
    shipmentFilter() {
      return {
        status: {
          label: this.$t('status'),
          type: 'select',
          value: {
            value: '',
          },
          options: [
            {text: this.$t('canceled'), value: '5'},
            {text: this.$t('PRINTED'), value: '3'},
            {text: this.$t('Recived by agent'), value: '12'},
            {text: this.$t('on_the_way'), value: '13'},
            {text: this.$t('issue'), value: '16'},
            {text: this.$t('In pickup point'), value: '15'},
            {text: this.$t('Delivered'), value: '14'},
            {text: this.$t('Waiting for approval'), value: '34'},
            {text: this.$t('Approved'), value: '35'},
          ],
        },
        ship_date: {
          label: this.$t('ship_date'),
          type: 'date',
          fromDate: {
            value: null
          },
          toDate: {
            value: null,
          },
        },
        created_at: {
          label: this.$t('created_at'),
          type: 'date',
          fromDate: {
            value: null
          },
          toDate: {
            value: null,
          },
        },
        subaccounts: {
          label: this.$t('account'),
          type: 'subaccount',
          value: {
            value: [],
            additional: '',
          },
        },
        custom_tags: {
          label: this.$t('Tags'),
          type: 'input',
          value: {
            value: '',
          },
        },
        shipping_agents: {
          label: this.$t('shipping_agent_name'),
          type: 'shippingAgent',
          value: {
            value: [],
            additional: '',
          },
        },
        shipping_product_name: {
          label: this.$t('Product name'),
          type: 'input',
          value: {
            value: '',
          },
        },
        weight: {
          label: this.$t('weight'),
          type: 'options',
          value: {
            value: '',
            additional: '',
          },
        },
        goods_type: {
          label: this.$t('goods_type'),
          type: 'select',
          value: {
            value: '',
          },
          options: [
            {text: `${this.$t('parcel')}`, value: '1'},
            {text: `${this.$t('document')}`, value: '2'},
            {text: `${this.$t('pallet')}`, value: '3'},
            {text: `${this.$t('load')}`, value: '4'},
          ],
        },
        receiver_reference: {
          label: `${this.$t('reciever_reference')}`,
          type: 'input',
          value: {
            value: '',
          },
        },
        receiver_company_name: {
          label: `${this.$t('receiver_company_name')}`,
          type: 'input',
          value: {
            value: '',
          },
        },
        receiver_name: {
          label: `${this.$t('receiver_name')}`,
          type: 'input',
          value: {
            value: '',
          },
        },
        receiver_address: {
          label: `${this.$t('receiver_address')}`,
          type: 'input',
          value: {
            value: '',
          },
        },
        receiver_post_code: {
          label: `${this.$t('receiver_post_code')}`,
          type: 'input',
          value: {
            value: '',
          },
        },
        receiver_country_id: {
          label: `${this.$t('receiver_country_id')}`,
          type: 'country',
          value: {
            value: [],
            additional: '',
          },
        },
        sender_reference: {
          label: `${this.$t('sender_reference')}`,
          type: 'input',
          value: {
            value: '',
          },
        },
        sender_company_name: {
          label: `${this.$t('sender_company_name')}`,
          type: 'input',
          value: {
            value: '',
          },
        },
        sender_name: {
          label: `${this.$t('sender_name')}`,
          type: 'input',
          value: {
            value: '',
          },
        },
        sender_address: {
          label: `${this.$t('sender_address')}`,
          type: 'input',
          value: {
            value: '',
          },
        },
        sender_post_code: {
          label: `${this.$t('sender_post_code')}`,
          type: 'input',
          value: {
            value: '',
          },
        },
        sender_country_id: {
          label: `${this.$t('sender_country_id')}`,
          type: 'country',
          value: {
            value: [],
            additional: '',
          },
        },
        goods_incoterm: {
          label: `${this.$t('goods_incoterm')}`,
          type: 'select',
          value: {
            value: '',
          },
          options: [
            {text: 'DAP', value: 'DAP'},
            {text: 'DDP', value: 'DDP'},
            {text: 'EXW', value: 'EXW'},
            {text: 'FCA', value: 'FCA'},
            {text: 'CPT', value: 'CPT'},
            {text: 'CIP', value: 'CIP'},
            {text: 'DPU', value: 'DPU'},
            {text: 'FAS', value: 'FAS'},
            {text: 'FOB', value: 'FOB'},
            {text: 'CFR', value: 'CFR'},
            {text: 'CIF', value: 'CIF'},
          ],
        },
        duty_paid_by: {
          label: `${this.$t('duty_paid_by')}`,
          type: 'select',
          value: {
            value: '',
          },
          options: [
            {text: `${this.$t('duty_paid_by')} ${this.$t('Seller').toLowerCase()}`, value: '1'},
            {text: `${this.$t('duty_paid_by')} ${this.$t('Reciever').toLowerCase()}`, value: '2'},
            {
              text: `${this.$t('duty_paid_by')} ${this.$t('Third party').toLowerCase()}`,
              value: '3'
            },
          ],
        },
        freight_paid_by: {
          label: `${this.$t('freight_paid_by')}`,
          type: 'select',
          value: {
            value: '',
          },
          options: [
            {text: `${this.$t('freight_paid_by')} ${this.$t('Seller').toLowerCase()}`, value: '1'},
            {text: `${this.$t('freight_paid_by')} ${this.$t('Other').toLowerCase()}`, value: '2'},
          ],
        },
        dangerous_goods: {
          label: `${this.$t('dangerous_goods')}`,
          type: 'select',
          value: {
            value: '',
            additional: '',
          },
          options: [
            {text: `${this.$t('yes')}`, value: '1'},
            {text: `${this.$t('no')}`, value: '0'},
          ],
        },
      }
    },
    itemsFilter() {
      return {
        name: {
          label: `${this.$t('name')}`,
          type: 'input',
          value: {
            value: '',
          },
        },
        description: {
          label: `${this.$t('description')}`,
          type: 'input',
          value: {
            value: '',
          },
        },
        is_visible: {
          label: `${this.$t('is_visible')}`,
          type: 'select',
          value: {
            value: '',
            additional: '',
          },
          options: [
            {text: `${this.$t('yes')}`, value: '1'},
            {text: `${this.$t('no')}`, value: '0'},
          ],
        },
        contains_dangerous_goods: {
          label: `${this.$t('dangerous_goods')}`,
          type: 'select',
          value: {
            value: '',
            additional: '',
          },
          options: [
            {text: `${this.$t('yes')}`, value: '1'},
            {text: `${this.$t('no')}`, value: '0'},
          ],
        },
        sku_code: {
          label: `${this.$t('sku_code')}`,
          type: 'input',
          value: {
            value: '',
          },
        },
        ean_number: {
          label: `${this.$t('ean_number')}`,
          type: 'input',
          value: {
            value: '',
          },
        },
        weight: {
          label: `${this.$t('weight')}`,
          type: 'input',
          value: {
            value: '',
          },
        },
        origin_country_id: {
          label: `${this.$t('country')}`,
          type: 'country',
          value: {
            value: [],
          },
        },
        hs_code: {
          label: `${this.$t('HS Code')}`,
          type: 'input',
          value: {
            value: '',
          },
        },
        sales_price: {
          label: `${this.$t('sales_price')}`,
          type: 'input',
          value: {
            value: '',
          },
        },
        purchase_price: {
          label: `${this.$t('purchase_price')}`,
          type: 'input',
          value: {
            value: '',
          },
        },
        min_temp: {
          label: `${this.$t('min_temp')}`,
          type: 'input',
          value: {
            value: '',
          },
        },
        max_temp: {
          label: `${this.$t('max_temperature')}`,
          type: 'input',
          value: {
            value: '',
          },
        },
      }
    },
    deleteReport(id) {
      this.$store.dispatch('DELETE_REPORTS', id).then(() => {
        this.$store.dispatch('GET_REPORTS');
      });
    },
    selectOptions(obj) {
      const options = [];
      for (const property in obj) {
        options.push({text: obj[property], value: property});
      }
      return options;
    },
    togglePopup() {
      this.openPopup = !this.openPopup;
      this.clearLocalFormData();
    },
    addReport() {
      this.togglePopup();
      this.openPopup = true;
      this.form.type = '1';
      this.form.file_type = 'xlsx';
      this.setDefaultFields('1');
      this.$store.dispatch('GET_REPORTS');
    },
    submitForm() {
      let dataObject = {};
      for (const [key] of Object.entries(this.formFields)) {
        if (['ship_date', 'created_at'].includes(key)) {
          if (this.formFields[key].value.fromDate || this.formFields[key].value.toDate) {
            dataObject[key] = this.formFields[key];
          }
          continue;
        }

        if (this.formFields[key].value != '') {
          if (!!this.formFields[key].value &&
            typeof this.formFields[key].value === 'string' ||
            !!this.formFields[key].value &&
            typeof this.formFields[key].value === 'number') {
            dataObject[key] = this.formFields[key];
          } else if (
            typeof this.formFields[key].value === 'array' &&
            this.formFields[key].value.length !== 0) {
            dataObject[key] = this.formFields[key];
          } else if (
            !!this.formFields[key].value &&
            typeof this.formFields[key].value === 'object' &&
            this.formFields[key].value.length !== 0) {
            dataObject[key] = this.formFields[key];
          }
        }
      }

      const action = 'ADD_REPORT';
      this.$store.dispatch(`${action}`, {
        form: this.form,
        where: JSON.parse(JSON.stringify(dataObject))
      }).then(() => {
        this.$store.dispatch('GET_REPORTS');
        this.openPopup = false;
        this.clearLocalFormData()
      });
    },
    openNewPopup() {
      this.togglePopup();
    },
    onValueChange(event) {
      if (this.formFields[event].value) {
        this.deleteIconToggle = true;
      } else {
        this.deleteIconToggle = false;
      }
    },
    deleteData(option) {
      if (option === 'created_at' || option === 'ship_date') {
        return this.formFields[option].value = {
          fromDate: '',
          toDate: ''
        }
      }

      if (
        typeof this.formFields[option].value === 'object' &&
        this.formFields[option].value?.length > 0
      ) {
        this.removeFilterParameter(option)
        return this.formFields[option].value = [];
      } else {
        this.removeFilterParameter(option)
        return this.formFields[option].value = '';
      }
    },
    removeFilterParameter(key) {
      this.$store.dispatch('SET_IS_CUSTOM_FILTER_NAME', false);
      this.$store.dispatch('REMOVE_EXISTING_FILTER_PARAM', key).then(() => {
        this.constructURL();
      });
    },
    constructURL() {
      this.$router.push({
        path: this.$route.path,
        query: {
          search: JSON.stringify(this.get_active_filter),
          searchTerm: JSON.stringify(this.get_search_term),
        },
      });
    },
    selectCountries(val) {
      this.formFields.country.value = val;
    },
    selectShippingAgents(val, key) {
      this.formFields[key].value = val;
    },
    selectSubaccounts(val, key) {
      this.formFields[key].value = val;
    },
  },
  watch: {
    get_import_queue: {
      handler(newValue) {
        newValue.forEach(queObj => {
          if(queObj.templateType === 'report_fields' && queObj.progressStatus === 100) {
            this.updateIterator++;
          }
        })

      },
      deep: true
    }
  }
};
</script>
